import { useState } from "react";
import WelcomeSection from "./components/WelcomeSection";
import InvestmentOverview from "./components/InvestmentOverview";
import ProfitGraph from "./components/ProfitGraph";
import RecentActivity from "./components/RecentActivity";
import InvestmentStats from "./components/InvestmentStats";
import ReferralProgress from "./components/ReferralProgress";
import PromotionalCards from "./components/PromotionalCards";
import BackHeader from "../../components/BackHeader";

const InvestmentDashboard = ({
    userName = "Jack",
    profileImage = "images/pictures/25s.jpg",
}) => {
    const [timeframe, setTimeframe] = useState("Monthly");
    const [dataType, setDataType] = useState("Earnings");

    // Recent activity data
    const recentActivity = [
        {
            date: "2024-03-15",
            type: "Deposit",
            amount: 1000,
            status: "Completed",
        },
        {
            date: "2024-03-14",
            type: "Earnings",
            amount: 125.5,
            status: "Completed",
        },
        {
            date: "2024-03-13",
            type: "Referral Bonus",
            amount: 500,
            status: "Pending",
        },
    ];

    return (
        <div
            className="container-fluid px-3 py-4"
            style={{
                minHeight: "100vh",
                maxWidth: "500px",
            }}
        >
            <BackHeader title="Invest Overview" />
            <WelcomeSection userName={userName} profileImage={profileImage} />
            <InvestmentOverview />
            <ProfitGraph
                timeframe={timeframe}
                setTimeframe={setTimeframe}
                dataType={dataType}
                setDataType={setDataType}
            />
            <RecentActivity recentActivity={recentActivity} />
            <InvestmentStats />
            <ReferralProgress />
            <PromotionalCards />
        </div>
    );
};

export default InvestmentDashboard;

// "use client";

// import { useState } from "react";
// import { ArrowLeft, DollarSign, Info } from "lucide-react";
// import { Line } from "react-chartjs-2";
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     PointElement,
//     LineElement,
//     Title,
//     Tooltip,
//     Filler,
//     Legend,
// } from "chart.js";
// import BackHeader from "../../components/BackHeader";

// // Register ChartJS components
// ChartJS.register(
//     CategoryScale,
//     LinearScale,
//     PointElement,
//     LineElement,
//     Title,
//     Tooltip,
//     Filler,
//     Legend
// );

// const InvestmentDashboard = ({
//     userName = "Jack",
//     profileImage = "/placeholder.svg?height=40&width=40",
// }) => {
//     const [timeframe, setTimeframe] = useState("Monthly");
//     const [dataType, setDataType] = useState("Earnings");

//     // Chart data
//     const chartData = {
//         labels: ["Jun", "Jul", "Aug", "Sep", "Oct", "Nov"],
//         datasets: [
//             {
//                 fill: true,
//                 label: "Portfolio Value",
//                 data: [25000, 42000, 35000, 30000, 45000, 50300],
//                 borderColor: "#4ECCA3",
//                 backgroundColor: "rgba(78, 204, 163, 0.1)",
//                 tension: 0.4,
//                 pointBackgroundColor: "#4ECCA3",
//                 pointBorderColor: "#000",
//                 pointBorderWidth: 2,
//                 pointRadius: 4,
//                 pointHoverRadius: 6,
//             },
//         ],
//     };

//     // Chart options
//     const chartOptions = {
//         responsive: true,
//         maintainAspectRatio: false,
//         plugins: {
//             legend: {
//                 display: false,
//             },
//             tooltip: {
//                 backgroundColor: "#1E1E1E",
//                 titleColor: "#fff",
//                 bodyColor: "#fff",
//                 borderColor: "#4ECCA3",
//                 borderWidth: 1,
//                 padding: 10,
//                 displayColors: false,
//                 callbacks: {
//                     label: (context) => `$${context.raw.toLocaleString()}`,
//                 },
//             },
//         },
//         scales: {
//             x: {
//                 grid: {
//                     display: false,
//                     drawBorder: false,
//                 },
//                 ticks: {
//                     color: "#6c757d",
//                 },
//             },
//             y: {
//                 grid: {
//                     color: "rgba(255, 255, 255, 0.05)",
//                     drawBorder: false,
//                 },
//                 ticks: {
//                     color: "#6c757d",
//                     callback: (value) => {
//                         if (value >= 1000) {
//                             return `$${value / 1000}k`;
//                         }
//                         return `$${value}`;
//                     },
//                 },
//             },
//         },
//     };

//     // Recent activity data
//     const recentActivity = [
//         {
//             date: "2024-03-15",
//             type: "Deposit",
//             amount: 1000,
//             status: "Completed",
//         },
//         {
//             date: "2024-03-14",
//             type: "Earnings",
//             amount: 125.5,
//             status: "Completed",
//         },
//         {
//             date: "2024-03-13",
//             type: "Referral Bonus",
//             amount: 500,
//             status: "Pending",
//         },
//     ];

//     return (
//         <div
//             className="container-fluid px-3 py-4"
//             style={{
//                 minHeight: "100vh",
//                 maxWidth: "500px",
//             }}
//         >
//             {/* Header */}
//             <BackHeader title="Invest Overview" />

//             {/* Welcome Section */}
//             <div className="d-flex justify-content-between align-items-center mb-4">
//                 <div>
//                     <h2 className="text-white fs-4 fw-bold mb-1">
//                         Welcome Back, {userName}!
//                     </h2>
//                     <p className="text-secondary mb-0 small">
//                         Track your investments, earnings, and impact in
//                         real-time
//                     </p>
//                 </div>
//                 <img
//                     src={profileImage || "/placeholder.svg"}
//                     alt={userName}
//                     className="rounded-circle"
//                     style={{ width: "40px", height: "40px" }}
//                 />
//             </div>

//             {/* Investment Overview Card */}
//             <div
//                 className="card mb-4 border-0"
//                 style={{
//                     backgroundColor: "rgba(18, 18, 30, 0.6)",
//                     borderRadius: "16px",
//                     border: "1px solid rgba(78, 78, 255, 0.2)",
//                 }}
//             >
//                 <div className="card-body p-4">
//                     <div className="d-flex justify-content-between align-items-center mb-4">
//                         <h3 className="text-white fs-5 m-0">
//                             Investment Overview
//                         </h3>
//                         <button
//                             className="btn btn-sm rounded-circle"
//                             style={{
//                                 backgroundColor: "rgba(255, 255, 255, 0.1)",
//                                 width: "32px",
//                                 height: "32px",
//                                 padding: "0",
//                             }}
//                         >
//                             <svg
//                                 width="18"
//                                 height="18"
//                                 viewBox="0 0 24 24"
//                                 fill="none"
//                                 xmlns="http://www.w3.org/2000/svg"
//                             >
//                                 <circle cx="12" cy="12" r="1" fill="white" />
//                                 <circle cx="6" cy="12" r="1" fill="white" />
//                                 <circle cx="18" cy="12" r="1" fill="white" />
//                             </svg>
//                         </button>
//                     </div>

//                     {/* Total Investment */}
//                     <div className="mb-4">
//                         <div className="d-flex align-items-center mb-2">
//                             <div
//                                 className="rounded me-2"
//                                 style={{
//                                     width: "16px",
//                                     height: "16px",
//                                     backgroundColor: "#8B80F9",
//                                 }}
//                             ></div>
//                             <span className="text-white">Total Investment</span>
//                         </div>
//                         <div className="d-flex align-items-center">
//                             <h4 className="text-white fs-1 fw-bold mb-0 me-3">
//                                 $19.5k
//                             </h4>
//                             <div
//                                 className="px-2 py-1 rounded"
//                                 style={{
//                                     backgroundColor: "rgba(78, 204, 163, 0.2)",
//                                     color: "#4ECCA3",
//                                 }}
//                             >
//                                 <span className="small">↑ 3.2%</span>
//                             </div>
//                         </div>
//                     </div>

//                     <hr style={{ borderColor: "rgba(255, 255, 255, 0.1)" }} />

//                     {/* Current Balance */}
//                     <div className="mb-4">
//                         <div className="d-flex align-items-center mb-2">
//                             <div
//                                 className="rounded me-2"
//                                 style={{
//                                     width: "16px",
//                                     height: "16px",
//                                     backgroundColor: "#8B80F9",
//                                 }}
//                             ></div>
//                             <span className="text-white">Current Balance</span>
//                         </div>
//                         <div className="d-flex align-items-center">
//                             <h4 className="text-white fs-1 fw-bold mb-0 me-3">
//                                 $51.8k
//                             </h4>
//                             <div
//                                 className="px-2 py-1 rounded"
//                                 style={{
//                                     backgroundColor: "rgba(220, 53, 69, 0.2)",
//                                     color: "#dc3545",
//                                 }}
//                             >
//                                 <span className="small">↓ 3.2%</span>
//                             </div>
//                         </div>
//                     </div>

//                     <hr style={{ borderColor: "rgba(255, 255, 255, 0.1)" }} />

//                     {/* Total Withdrawals */}
//                     <div className="mb-4">
//                         <div className="d-flex align-items-center mb-2">
//                             <div
//                                 className="rounded me-2"
//                                 style={{
//                                     width: "16px",
//                                     height: "16px",
//                                     backgroundColor: "#8B80F9",
//                                 }}
//                             ></div>
//                             <span className="text-white">
//                                 Total Withdrawals
//                             </span>
//                         </div>
//                         <div className="d-flex align-items-center">
//                             <h4 className="text-white fs-1 fw-bold mb-0 me-3">
//                                 $72.1k
//                             </h4>
//                             <div
//                                 className="px-2 py-1 rounded"
//                                 style={{
//                                     backgroundColor: "rgba(78, 204, 163, 0.2)",
//                                     color: "#4ECCA3",
//                                 }}
//                             >
//                                 <span className="small">↑ 2%</span>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Bar Chart */}
//                     <div style={{ height: "200px" }}>
//                         <div className="position-relative h-100">
//                             {/* Y-axis labels */}
//                             <div
//                                 className="position-absolute start-0 h-100 d-flex flex-column justify-content-between"
//                                 style={{ width: "50px" }}
//                             >
//                                 <span className="text-secondary small">
//                                     $100k
//                                 </span>
//                                 <span className="text-secondary small">
//                                     $75k
//                                 </span>
//                                 <span className="text-secondary small">
//                                     $50k
//                                 </span>
//                                 <span className="text-secondary small">
//                                     $25k
//                                 </span>
//                                 <span className="text-secondary small">
//                                     $0k
//                                 </span>
//                             </div>

//                             {/* Chart area */}
//                             <div className="ms-5 h-100 d-flex align-items-end justify-content-between">
//                                 {/* June */}
//                                 <div
//                                     className="d-flex flex-column align-items-center"
//                                     style={{ width: "40px" }}
//                                 >
//                                     <div
//                                         className="w-100 rounded-top"
//                                         style={{
//                                             height: "80px",
//                                             backgroundColor: "#8B80F9",
//                                         }}
//                                     ></div>
//                                     <div
//                                         className="w-100"
//                                         style={{
//                                             height: "60px",
//                                             backgroundColor: "#7A6FF8",
//                                         }}
//                                     ></div>
//                                     <div
//                                         className="w-100 rounded-bottom"
//                                         style={{
//                                             height: "40px",
//                                             backgroundColor: "#6A5FF7",
//                                         }}
//                                     ></div>
//                                     <span className="text-secondary small mt-2">
//                                         Jun
//                                     </span>
//                                 </div>

//                                 {/* July */}
//                                 <div
//                                     className="d-flex flex-column align-items-center"
//                                     style={{ width: "40px" }}
//                                 >
//                                     <div
//                                         className="w-100 rounded-top"
//                                         style={{
//                                             height: "50px",
//                                             backgroundColor: "#8B80F9",
//                                         }}
//                                     ></div>
//                                     <div
//                                         className="w-100"
//                                         style={{
//                                             height: "40px",
//                                             backgroundColor: "#7A6FF8",
//                                         }}
//                                     ></div>
//                                     <div
//                                         className="w-100 rounded-bottom"
//                                         style={{
//                                             height: "30px",
//                                             backgroundColor: "#6A5FF7",
//                                         }}
//                                     ></div>
//                                     <span className="text-secondary small mt-2">
//                                         Jul
//                                     </span>
//                                 </div>

//                                 {/* August */}
//                                 <div
//                                     className="d-flex flex-column align-items-center"
//                                     style={{ width: "40px" }}
//                                 >
//                                     <div
//                                         className="w-100 rounded-top"
//                                         style={{
//                                             height: "60px",
//                                             backgroundColor: "#8B80F9",
//                                         }}
//                                     ></div>
//                                     <div
//                                         className="w-100"
//                                         style={{
//                                             height: "45px",
//                                             backgroundColor: "#7A6FF8",
//                                         }}
//                                     ></div>
//                                     <div
//                                         className="w-100 rounded-bottom"
//                                         style={{
//                                             height: "20px",
//                                             backgroundColor: "#6A5FF7",
//                                         }}
//                                     ></div>
//                                     <span className="text-secondary small mt-2">
//                                         Aug
//                                     </span>
//                                 </div>

//                                 {/* September */}
//                                 <div
//                                     className="d-flex flex-column align-items-center"
//                                     style={{ width: "40px" }}
//                                 >
//                                     <div
//                                         className="w-100 rounded-top"
//                                         style={{
//                                             height: "75px",
//                                             backgroundColor: "#8B80F9",
//                                         }}
//                                     ></div>
//                                     <div
//                                         className="w-100"
//                                         style={{
//                                             height: "55px",
//                                             backgroundColor: "#7A6FF8",
//                                         }}
//                                     ></div>
//                                     <div
//                                         className="w-100 rounded-bottom"
//                                         style={{
//                                             height: "35px",
//                                             backgroundColor: "#6A5FF7",
//                                         }}
//                                     ></div>
//                                     <span className="text-secondary small mt-2">
//                                         Sep
//                                     </span>
//                                 </div>

//                                 {/* October */}
//                                 <div
//                                     className="d-flex flex-column align-items-center"
//                                     style={{ width: "40px" }}
//                                 >
//                                     <div
//                                         className="w-100 rounded-top"
//                                         style={{
//                                             height: "65px",
//                                             backgroundColor: "#8B80F9",
//                                         }}
//                                     ></div>
//                                     <div
//                                         className="w-100"
//                                         style={{
//                                             height: "45px",
//                                             backgroundColor: "#7A6FF8",
//                                         }}
//                                     ></div>
//                                     <div
//                                         className="w-100 rounded-bottom"
//                                         style={{
//                                             height: "25px",
//                                             backgroundColor: "#6A5FF7",
//                                         }}
//                                     ></div>
//                                     <span className="text-secondary small mt-2">
//                                         Oct
//                                     </span>
//                                 </div>

//                                 {/* November */}
//                                 <div
//                                     className="d-flex flex-column align-items-center"
//                                     style={{ width: "40px" }}
//                                 >
//                                     <div
//                                         className="w-100 rounded-top"
//                                         style={{
//                                             height: "45px",
//                                             backgroundColor: "#8B80F9",
//                                         }}
//                                     ></div>
//                                     <div
//                                         className="w-100"
//                                         style={{
//                                             height: "35px",
//                                             backgroundColor: "#7A6FF8",
//                                         }}
//                                     ></div>
//                                     <div
//                                         className="w-100 rounded-bottom"
//                                         style={{
//                                             height: "25px",
//                                             backgroundColor: "#6A5FF7",
//                                         }}
//                                     ></div>
//                                     <span className="text-secondary small mt-2">
//                                         Nov
//                                     </span>
//                                 </div>
//                             </div>

//                             {/* Horizontal grid lines */}
//                             <div className="position-absolute top-0 start-0 end-0 h-100">
//                                 <div
//                                     className="border-bottom border-secondary opacity-25"
//                                     style={{ height: "20%" }}
//                                 ></div>
//                                 <div
//                                     className="border-bottom border-secondary opacity-25"
//                                     style={{ height: "20%" }}
//                                 ></div>
//                                 <div
//                                     className="border-bottom border-secondary opacity-25"
//                                     style={{ height: "20%" }}
//                                 ></div>
//                                 <div
//                                     className="border-bottom border-secondary opacity-25"
//                                     style={{ height: "20%" }}
//                                 ></div>
//                                 <div
//                                     className="border-bottom border-secondary opacity-25"
//                                     style={{ height: "20%" }}
//                                 ></div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Profit Graph Card */}
//             <div
//                 className="card mb-4 border-0"
//                 style={{
//                     backgroundColor: "rgba(18, 18, 30, 0.6)",
//                     borderRadius: "16px",
//                 }}
//             >
//                 <div className="card-body p-3">
//                     <div className="d-flex justify-content-between align-items-center mb-3">
//                         <h3 className="text-white fs-5 m-0">Profit graph</h3>
//                         <div className="d-flex">
//                             <div
//                                 className="me-2 px-3 py-1 rounded-pill"
//                                 style={{
//                                     backgroundColor: "rgba(255, 255, 255, 0.1)",
//                                     cursor: "pointer",
//                                 }}
//                             >
//                                 <span className="text-secondary small">
//                                     {timeframe} ▼
//                                 </span>
//                             </div>
//                             <div
//                                 className="px-3 py-1 rounded-pill"
//                                 style={{
//                                     backgroundColor: "rgba(255, 255, 255, 0.1)",
//                                     cursor: "pointer",
//                                 }}
//                             >
//                                 <span className="text-secondary small">
//                                     {dataType} ▼
//                                 </span>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Current Value */}
//                     <div className="position-relative mb-2">
//                         <div
//                             className="position-absolute start-50 top-50 translate-middle text-center"
//                             style={{
//                                 backgroundColor: "rgba(18, 18, 30, 0.8)",
//                                 padding: "8px 12px",
//                                 borderRadius: "8px",
//                                 zIndex: 10,
//                             }}
//                         >
//                             <h4 className="text-white fs-4 fw-bold mb-0">
//                                 $50,3k
//                             </h4>
//                             <span className="text-success small">↑ 3.2%</span>
//                         </div>

//                         {/* Chart */}
//                         <div style={{ height: "200px" }}>
//                             <Line data={chartData} options={chartOptions} />
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Recent Activity Card */}
//             <div
//                 className="card mb-4 border-0"
//                 style={{
//                     backgroundColor: "rgba(18, 18, 30, 0.6)",
//                     borderRadius: "16px",
//                 }}
//             >
//                 <div className="card-body p-3">
//                     <h3 className="text-white fs-5 mb-3">Recent Activity</h3>

//                     <div className="table-responsive">
//                         <table className="table table-dark table-borderless mb-0">
//                             <thead>
//                                 <tr className="text-secondary">
//                                     <th className="ps-0">Date</th>
//                                     <th>Type</th>
//                                     <th>Ammount</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {recentActivity.map((activity, index) => (
//                                     <tr key={index} className="text-white">
//                                         <td className="ps-0">
//                                             {activity.date.substring(5)}
//                                         </td>
//                                         <td>{activity.type}</td>
//                                         <td className="d-flex justify-content-between">
//                                             ${activity.amount}
//                                             <span
//                                                 className={`badge rounded-pill px-3 ${
//                                                     activity.status ===
//                                                     "Completed"
//                                                         ? "bg-success"
//                                                         : "bg-warning"
//                                                 }`}
//                                                 style={{
//                                                     backgroundColor:
//                                                         activity.status ===
//                                                         "Completed"
//                                                             ? "#4ECCA3"
//                                                             : "#FFC107",
//                                                 }}
//                                             >
//                                                 {activity.status}
//                                             </span>
//                                         </td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>
//             </div>

//             {/* Investment Stats Cards */}
//             <div className="row g-3 mb-4">
//                 <div className="col-12">
//                     <div
//                         className="card border-0 h-100"
//                         style={{
//                             backgroundColor: "rgba(18, 18, 30, 0.6)",
//                             borderRadius: "16px",
//                         }}
//                     >
//                         <div className="card-body p-3">
//                             <div className="d-flex justify-content-between align-items-center">
//                                 <div className="d-flex align-items-center">
//                                     <div
//                                         className="rounded-circle me-3 d-flex justify-content-center align-items-center"
//                                         style={{
//                                             width: "40px",
//                                             height: "40px",
//                                             backgroundColor:
//                                                 "rgba(255, 255, 255, 0.1)",
//                                         }}
//                                     >
//                                         <DollarSign
//                                             size={20}
//                                             className="text-white"
//                                         />
//                                     </div>
//                                     <span className="text-secondary">
//                                         Daily Returns
//                                     </span>
//                                 </div>
//                                 <div className="text-end">
//                                     <h4 className="text-primary fs-3 fw-bold mb-0">
//                                         $49.99
//                                     </h4>
//                                     <span className="text-secondary small">
//                                         USD
//                                     </span>
//                                 </div>
//                                 <span className="text-secondary small position-absolute top-0 end-0 mt-2 me-3">
//                                     Today
//                                 </span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="col-12">
//                     <div
//                         className="card border-0 h-100"
//                         style={{
//                             backgroundColor: "rgba(18, 18, 30, 0.6)",
//                             borderRadius: "16px",
//                         }}
//                     >
//                         <div className="card-body p-3">
//                             <div className="d-flex justify-content-between align-items-center">
//                                 <div className="d-flex align-items-center">
//                                     <div
//                                         className="rounded-circle me-3 d-flex justify-content-center align-items-center"
//                                         style={{
//                                             width: "40px",
//                                             height: "40px",
//                                             backgroundColor:
//                                                 "rgba(255, 255, 255, 0.1)",
//                                         }}
//                                     >
//                                         <svg
//                                             width="20"
//                                             height="20"
//                                             viewBox="0 0 24 24"
//                                             fill="none"
//                                             xmlns="http://www.w3.org/2000/svg"
//                                         >
//                                             <path
//                                                 d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
//                                                 stroke="#4ECCA3"
//                                                 strokeWidth="2"
//                                                 strokeLinecap="round"
//                                                 strokeLinejoin="round"
//                                             />
//                                             <path
//                                                 d="M8 14L12 10L16 14"
//                                                 stroke="#4ECCA3"
//                                                 strokeWidth="2"
//                                                 strokeLinecap="round"
//                                                 strokeLinejoin="round"
//                                             />
//                                         </svg>
//                                     </div>
//                                     <span className="text-secondary">
//                                         MAC Token Balance
//                                     </span>
//                                 </div>
//                                 <div className="text-end">
//                                     <h4 className="text-primary fs-3 fw-bold mb-0">
//                                         5,000
//                                     </h4>
//                                     <span className="text-secondary small">
//                                         MAC
//                                     </span>
//                                 </div>
//                                 <span className="text-secondary small position-absolute top-0 end-0 mt-2 me-3">
//                                     Today
//                                 </span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="col-12">
//                     <div
//                         className="card border-0 h-100"
//                         style={{
//                             backgroundColor: "rgba(18, 18, 30, 0.6)",
//                             borderRadius: "16px",
//                         }}
//                     >
//                         <div className="card-body p-3">
//                             <div className="d-flex justify-content-between align-items-center">
//                                 <div className="d-flex align-items-center">
//                                     <div
//                                         className="rounded-circle me-3 d-flex justify-content-center align-items-center"
//                                         style={{
//                                             width: "40px",
//                                             height: "40px",
//                                             backgroundColor:
//                                                 "rgba(255, 255, 255, 0.1)",
//                                         }}
//                                     >
//                                         <DollarSign
//                                             size={20}
//                                             className="text-white"
//                                         />
//                                     </div>
//                                     <span className="text-secondary">
//                                         Active Investments
//                                     </span>
//                                 </div>
//                                 <div className="text-end">
//                                     <h4 className="text-primary fs-3 fw-bold mb-0">
//                                         $4999
//                                     </h4>
//                                     <span className="text-secondary small">
//                                         Gold Plan
//                                     </span>
//                                 </div>
//                                 <span className="text-secondary small position-absolute top-0 end-0 mt-2 me-3">
//                                     Today
//                                 </span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="col-12">
//                     <div
//                         className="card border-0 h-100"
//                         style={{
//                             backgroundColor: "rgba(18, 18, 30, 0.6)",
//                             borderRadius: "16px",
//                         }}
//                     >
//                         <div className="card-body p-3">
//                             <div className="d-flex justify-content-between align-items-center">
//                                 <div className="d-flex align-items-center">
//                                     <div
//                                         className="rounded-circle me-3 d-flex justify-content-center align-items-center"
//                                         style={{
//                                             width: "40px",
//                                             height: "40px",
//                                             backgroundColor:
//                                                 "rgba(255, 255, 255, 0.1)",
//                                         }}
//                                     >
//                                         <svg
//                                             width="20"
//                                             height="20"
//                                             viewBox="0 0 24 24"
//                                             fill="none"
//                                             xmlns="http://www.w3.org/2000/svg"
//                                         >
//                                             <path
//                                                 d="M17 21V19C17 16.7909 15.2091 15 13 15H5C2.79086 15 1 16.7909 1 19V21"
//                                                 stroke="white"
//                                                 strokeWidth="2"
//                                                 strokeLinecap="round"
//                                                 strokeLinejoin="round"
//                                             />
//                                             <path
//                                                 d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
//                                                 stroke="white"
//                                                 strokeWidth="2"
//                                                 strokeLinecap="round"
//                                                 strokeLinejoin="round"
//                                             />
//                                             <path
//                                                 d="M23 21V19C22.9986 17.1771 21.765 15.5857 20 15.13"
//                                                 stroke="white"
//                                                 strokeWidth="2"
//                                                 strokeLinecap="round"
//                                                 strokeLinejoin="round"
//                                             />
//                                             <path
//                                                 d="M16 3.13C17.7699 3.58317 19.0078 5.17799 19.0078 7.005C19.0078 8.83201 17.7699 10.4268 16 10.88"
//                                                 stroke="white"
//                                                 strokeWidth="2"
//                                                 strokeLinecap="round"
//                                                 strokeLinejoin="round"
//                                             />
//                                         </svg>
//                                     </div>
//                                     <span className="text-secondary">
//                                         Referral Rewards
//                                     </span>
//                                 </div>
//                                 <div className="text-end">
//                                     <h4 className="text-primary fs-3 fw-bold mb-0">
//                                         250
//                                     </h4>
//                                     <span className="text-secondary small">
//                                         MAC Earned
//                                     </span>
//                                 </div>
//                                 <span className="text-secondary small position-absolute top-0 end-0 mt-2 me-3">
//                                     Status
//                                 </span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="col-12">
//                     <div
//                         className="card border-0 h-100"
//                         style={{
//                             backgroundColor: "rgba(18, 18, 30, 0.6)",
//                             borderRadius: "16px",
//                         }}
//                     >
//                         <div className="card-body p-3">
//                             <div className="d-flex justify-content-between align-items-center">
//                                 <div className="d-flex align-items-center">
//                                     <div
//                                         className="rounded-circle me-3 d-flex justify-content-center align-items-center"
//                                         style={{
//                                             width: "40px",
//                                             height: "40px",
//                                             backgroundColor:
//                                                 "rgba(255, 255, 255, 0.1)",
//                                         }}
//                                     >
//                                         <svg
//                                             width="20"
//                                             height="20"
//                                             viewBox="0 0 24 24"
//                                             fill="none"
//                                             xmlns="http://www.w3.org/2000/svg"
//                                         >
//                                             <path
//                                                 d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
//                                                 stroke="#4ECCA3"
//                                                 strokeWidth="2"
//                                                 strokeLinecap="round"
//                                                 strokeLinejoin="round"
//                                             />
//                                             <path
//                                                 d="M12 6V12L16 14"
//                                                 stroke="#4ECCA3"
//                                                 strokeWidth="2"
//                                                 strokeLinecap="round"
//                                                 strokeLinejoin="round"
//                                             />
//                                         </svg>
//                                     </div>
//                                     <span className="text-secondary">
//                                         Lock-In Period Remaining
//                                     </span>
//                                 </div>
//                                 <div className="text-end">
//                                     <h4 className="text-primary fs-3 fw-bold mb-0">
//                                         25
//                                     </h4>
//                                     <span className="text-secondary small">
//                                         Days
//                                     </span>
//                                 </div>
//                                 <span className="text-secondary small position-absolute top-0 end-0 mt-2 me-3">
//                                     Today
//                                 </span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Referral Progress Card */}
//             <div
//                 className="card mb-4 border-0"
//                 style={{
//                     backgroundColor: "rgba(18, 18, 30, 0.6)",
//                     borderRadius: "16px",
//                 }}
//             >
//                 <div className="card-body p-3">
//                     <div className="d-flex justify-content-between align-items-center mb-3">
//                         <h3 className="text-white fs-5 m-0">
//                             Referral Progress
//                         </h3>
//                         <Info size={18} className="text-secondary" />
//                     </div>

//                     <div className="row g-3">
//                         <div className="col-6">
//                             <div
//                                 className="card border-0 h-100"
//                                 style={{
//                                     backgroundColor: "rgba(18, 18, 30, 0.8)",
//                                     borderRadius: "12px",
//                                 }}
//                             >
//                                 <div className="card-body p-3 text-center">
//                                     <div
//                                         className="position-relative mb-3"
//                                         style={{ height: "120px" }}
//                                     >
//                                         <div className="position-absolute top-50 start-50 translate-middle">
//                                             <svg
//                                                 width="120"
//                                                 height="120"
//                                                 viewBox="0 0 120 120"
//                                             >
//                                                 <circle
//                                                     cx="60"
//                                                     cy="60"
//                                                     r="54"
//                                                     fill="none"
//                                                     stroke="#2A2A3C"
//                                                     strokeWidth="12"
//                                                 />
//                                                 <circle
//                                                     cx="60"
//                                                     cy="60"
//                                                     r="54"
//                                                     fill="none"
//                                                     stroke="#4ECCA3"
//                                                     strokeWidth="12"
//                                                     strokeDasharray="339.3"
//                                                     strokeDashoffset="84.8"
//                                                     transform="rotate(-90 60 60)"
//                                                 />
//                                             </svg>
//                                             <div className="position-absolute top-50 start-50 translate-middle text-white fs-3 fw-bold">
//                                                 75%
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <p className="text-white small mb-0">
//                                         You're 75% closer to earning 5,000 MAC
//                                         tokens!
//                                     </p>
//                                 </div>
//                             </div>
//                         </div>

//                         <div className="col-6">
//                             <div className="row g-3 h-100">
//                                 <div className="col-12">
//                                     <div
//                                         className="card border-0 h-100"
//                                         style={{
//                                             backgroundColor:
//                                                 "rgba(18, 18, 30, 0.8)",
//                                             borderRadius: "12px",
//                                         }}
//                                     >
//                                         <div className="card-body p-3 text-center">
//                                             <h4 className="text-white fs-2 fw-bold mb-1">
//                                                 12
//                                             </h4>
//                                             <p className="text-secondary small mb-0">
//                                                 Total Referrals
//                                             </p>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="col-12">
//                                     <div
//                                         className="card border-0 h-100"
//                                         style={{
//                                             backgroundColor:
//                                                 "rgba(18, 18, 30, 0.8)",
//                                             borderRadius: "12px",
//                                         }}
//                                     >
//                                         <div className="card-body p-3 text-center">
//                                             <h4 className="text-white fs-2 fw-bold mb-1">
//                                                 8
//                                             </h4>
//                                             <p className="text-secondary small mb-0">
//                                                 Active Investors
//                                             </p>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Promotional Cards */}
//             <div className="row g-4 mb-4">
//                 {/* Grow Your Earnings Card */}
//                 <div className="col-12">
//                     <div
//                         className="card border-0"
//                         style={{
//                             backgroundColor: "rgba(18, 18, 30, 0.6)",
//                             borderRadius: "16px",
//                         }}
//                     >
//                         <div className="card-body p-4">
//                             <h3 className="text-white fs-4 fw-bold mb-2">
//                                 Grow Your Earnings
//                             </h3>
//                             <p className="text-secondary mb-4">
//                                 Invite friends and earn up to 5,000 MAC tokens
//                                 in rewards!
//                             </p>

//                             <button
//                                 className="btn px-4 py-2"
//                                 style={{
//                                     backgroundColor: "#2E2CB2",
//                                     color: "white",
//                                     borderRadius: "8px",
//                                 }}
//                             >
//                                 Invite Friends <span className="ms-2">→</span>
//                             </button>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Upgrade Your Plan Card */}
//                 <div className="col-12">
//                     <div
//                         className="card border-0"
//                         style={{
//                             backgroundColor: "rgba(18, 18, 30, 0.6)",
//                             borderRadius: "16px",
//                         }}
//                     >
//                         <div className="card-body p-4">
//                             <h3 className="text-white fs-4 fw-bold mb-2">
//                                 Upgrade Your Plan
//                             </h3>
//                             <p className="text-secondary mb-4">
//                                 Maximize your earnings with our premium
//                                 investment plans!
//                             </p>

//                             <button
//                                 className="btn px-4 py-2"
//                                 style={{
//                                     backgroundColor: "#2E2CB2",
//                                     color: "white",
//                                     borderRadius: "8px",
//                                 }}
//                             >
//                                 Upgrade Plans <span className="ms-2">→</span>
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default InvestmentDashboard;
